import { SlotType, ManualSlotType } from "../constants/commonenums";

export class OpenBookingDTO {
    BookingId: number;
    FromDate: string;
    ToDate: string;
    Location: number;
    LocationName: string;
    BookingSize: number;
    MembershipDetail: string;
    GuestTypes: CoverType[];
    BookingTypes:BookingType[];
    Slots: any[];

    constructor(bookingId, fromDate, toDate, location, locationName,
        bookingSize, membershipDetails, guestTypes,bookingTypes, slots) {
        this.BookingId = bookingId;
        this.FromDate = fromDate;
        this.ToDate = toDate;
        this.Location = location;
        this.LocationName = locationName;
        this.BookingSize = bookingSize;
        this.MembershipDetail = membershipDetails;
        this.GuestTypes = guestTypes;
        this.BookingTypes=bookingTypes;
        this.Slots = slots;
    }
}

export class CoverType {
    CoverTypeId: number;
    Covers: number;
}

export class BookingType {
    BookingTypeId: number;
    BookingTypes: number;
}

export class SlotDTO {
    Id: number = null;
    Type: SlotType = null;
    DateTime: string = null;
    PartyId: number = null;
    OriginalMinPartySize: number = null;
    OriginalMaxPartySize: number = null;
    LimitedMinPartySize: number = null;
    LimitedMaxPartySize: number = null;
    IsWebReservable: boolean = false;
    IsDisabled: boolean = false;
    SeatingAreaId: number = null;
    LockedAt: Date = null;
    LockExpiresAt: Date = null;
    ManualSlotType: ManualSlotType = null;
    UpdatedAt: Date = null;
}